export const userRoles = ["player", "club"] as const;
export type UserRole = (typeof userRoles)[number];

// Langues de l'interface (miroir de supportedLngs dans apps/web/src/lib/i18next.ts).
// Sert aussi à forcer la langue de la page de paiement Stripe : sans elle, Stripe
// se cale sur le navigateur, pas sur la langue choisie dans l'app.
export const appLocales = ["en-US", "fr-FR"] as const;
export type AppLocale = (typeof appLocales)[number];

export const playerGenders = ["female", "male"] as const;
export type UserGender = (typeof playerGenders)[number];

export const playerPlayingStyles = ["aggressive-baseliner", "all-rounder", "counter-attacker", "defensive-player", "net-player"] as const;
export type PlayerPlayingStyle = (typeof playerPlayingStyles)[number];

export const playerLaterality = ["left-handed", "right-handed"] as const;
export type PlayerLaterality = (typeof playerLaterality)[number];

export const playerPreferredSurface = ["indoor-hard", "outdoor-hard", "indoor-clay", "outdoor-clay"] as const;
export type PlayerPreferredSurface = (typeof playerPreferredSurface)[number];

export const playerFFTranking = ["3/6", "2/6", "1/6", "0", "-2/6", "-4/6", "-15", "T100"] as const;
export type PlayerFFTranking = (typeof playerFFTranking)[number];

export const frDivisionsList = ["Pro A", "Pro B", "Nationale 1", "Nationale 2", "Nationale 3", "Nationale 4", "Pré Nationale", "Régionale"] as const;
export type FrDivision = (typeof frDivisionsList)[number];

export const deDivisionsList = ["Division 1", "Division 2", "Division 3", "Division 4", "Division 5", "Division 6"] as const;
export type DeDivision = (typeof deDivisionsList)[number];

export const itDivisionsList = ["Serie A1", "Serie A2", "Serie B1", "Serie B2", "Serie C", "Serie D"] as const;
export type ItDivision = (typeof itDivisionsList)[number];

export const playerMatchAvailabilities = ["available", "not-available"] as const;
export type PlayerMatchAvailability = (typeof playerMatchAvailabilities)[number];

export const clubHosting = ["possible", "not-possible"] as const;
export type ClubHosting = (typeof clubHosting)[number];

export const clubTraveling = ["covered", "not-covered"] as const;
export type ClubTraveling = (typeof clubTraveling)[number];

export const rankingTypes = ["FFT", "UTR", "ATP", "WTA", "ITF"] as const;
export type RankingTypes = typeof rankingTypes[number];

// "draft" : tournoi préparé par un club sans abonnement. Il est conservé tel quel
// et n'est visible que de son club, jusqu'à publication après souscription.
export const tournamentStatus = ["open", "closed", "archived", "draft"] as const;
export type TournamentStatus = (typeof tournamentStatus)[number];

export const tournamentPrizesCategorie = ["winnerPrize", "finalistPrize", "semiFinalistPrize", "quarterFinalistPrize", "roundOf16Prize"] as const;
export type TournamentPrizesCategorie = (typeof tournamentPrizesCategorie)[number];
